import type { ReactNode } from 'react';
import type { DateFormatPreset, OrgDateFormat, OrgTimeFormat } from '@/shared/utils/dateFormat';
import type { OrgTimezone } from '@/shared/utils/timezone';
import { useOrgSettings } from '@/shared/context/OrgSettingsContext';

interface TimezoneContextType {
  timezone: OrgTimezone;
  dateFormat: OrgDateFormat;
  timeFormat: OrgTimeFormat;
  loading: boolean;
  timezoneLabel: string;
  getDatePattern: (preset: DateFormatPreset) => string;
  formatOrgDate: (
    value: Date | string | number | null | undefined,
    preset?: DateFormatPreset
  ) => string;
  formatInOrgTimezone: (value: Date | string | number | null | undefined, formatStr: string) => string;
  zonedDateTimeToUtc: (datePart: string, timePart: string) => Date;
  extractOrgDateParts: (value: Date | string | number | null | undefined) => { date: string; time: string } | null;
  toCalendarDisplayDate: (value: Date | string | number | null | undefined) => Date;
  refreshTimezone: () => Promise<void>;
}

/** @deprecated Use OrgSettingsProvider instead */
export const TimezoneProvider = ({ children }: { children: ReactNode }) => <>{children}</>;

export const useTimezone = (): TimezoneContextType => {
  const org = useOrgSettings();
  return {
    timezone: org.timezone,
    dateFormat: org.dateFormat,
    timeFormat: org.timeFormat,
    loading: org.loading,
    timezoneLabel: org.timezoneLabel,
    getDatePattern: org.getDatePattern,
    formatOrgDate: org.formatOrgDate,
    formatInOrgTimezone: org.formatInOrgTimezone,
    zonedDateTimeToUtc: org.zonedDateTimeToUtc,
    extractOrgDateParts: org.extractOrgDateParts,
    toCalendarDisplayDate: org.toCalendarDisplayDate,
    refreshTimezone: org.refreshOrgSettings,
  };
};
